import React, { useContext } from 'react';
import { i18n as I18n, withTranslation } from '../utils/i18n';

// context
import { AuthContext } from '../state/auth';

// components
import Page from '../components/page';
import LoginActionPanel from '../components/loginActionPanel';
import ResendConfirmationForm from '../components/forms/resendConfirmation';

const ResendConfirmationEmailPage = () => {
  const { actions } = useContext(AuthContext);

  const resendEmail = async ({ email }, { setSubmitting = () => {} } = {}) => {
    await actions.resendEmailConfirmationLink(email);
    setSubmitting(false);
  };

  const heading = I18n.t('resend_confirmation.heading');

  return (
    <Page title={heading}>
      <LoginActionPanel
        heading={heading}
        showResendConfirmationLink={false}
        showRegisterLink={false}
      >
        <ResendConfirmationForm onSubmit={resendEmail} />
      </LoginActionPanel>
    </Page>
  );
};

ResendConfirmationEmailPage.getInitialProps = async () => ({
  namespacesRequired: ['common'],
});

export default withTranslation('common')(ResendConfirmationEmailPage);
